<template>
  <div class="main">
    <div class="main__container">
      <div class="content pt-10">

        <!-- Hero -->
        <div class="flex flex-row w-full justify-between flex-wrap">

          <div class="flex flex-auto flex-col w-full sm:w-full md:w-1/2 md:max-w-[33.75rem] lg:max-w-[40rem] mb-[3.125rem] md:mb-0">
            <div class="flex flex-none flex-wrap mb-5 text-center text-[3rem] leading-[3.25rem] md:text-left md:text-[3.5rem] md:leading-[4.688rem] lg:text-[4.875rem] lg:leading-[6.25rem] font-[850] xl:text-[5.063rem] xl:leading-[5.625rem] text-white">
              {{ $t("pst-private.landing.hero-is-cheaper-with-private", {p: 'PRIVATE'}) }}
            </div>
            <div class="flex flex-none text-white text-[1.75rem] font-[400] leading-[2.25rem] mb-[4.75rem] justify-center md:justify-start text-center md:text-left">
              {{ $t("pst-private.landing.discount-cashback-full-access") }}
            </div>
            <div class="flex flex-none flex-row flex-wrap justify-between">

              <div class="w-full sm:w-[49%] lg:max-w-[18.875rem] mb-2 sm:mb-0">
                <a href="#" @click.stop="onClickSubscribe">
                  <div class="btn-common btn-orange w-full !h-[4rem] !text-[1rem] lg:!text-[1.25rem]">
                    {{ $t("pst-private.landing.subscribe-from") }} {{ startPriceUsd }}&nbsp;$
                  </div>
                </a>
              </div>

              <div class="w-full sm:w-[49%] lg:max-w-[18.875rem]">
                <a href="#" @click.stop="onClickSubscribe">
                  <div class="btn-common btn-gray w-full !h-[4rem] !text-[1rem] lg:!text-[1.25rem]">
                    {{ $t("pst-private.landing.support-private") }}
                  </div>
                </a>
              </div>

            </div>
          </div>

          <div class="flex flex-none w-full md:w-1/2">
            <nuxt-img
                class="lg:rendering-pixelated w-full h-fit m-auto max-w-[30.5rem]"
                src="/img/hero-private-cards.png"
                format="png"
                width="489"
                height="519"
            />
          </div>
        </div>

        <!-- Discount -->
        <div class="flex flex-col text-center text-white text-[3.25rem] md:text-[6.25rem] font-[200] leading-[108%] my-[7.5rem]">
          <div class="flex flex-none w-full justify-center">{{ $t("pst-private.landing.three-reason-subscribe", { p: 'PRIVATE'}) }}</div>
        </div>

        <!-- up to -->
        <div class="flex flex-row flex-wrap w-full justify-between rounded-[2.5rem] bg-[#F3F4F7] py-[1.25rem] md:px-[3.875rem] md:py-[2.5rem]">
          <div class="flex flex-none w-full mb-2 md:mb-0 md:w-1/2 order-2 md:order-1 p-[0.938rem] sm:p-0">
            <nuxt-img
                class="lg:rendering-pixelated w-full h-fit m-auto max-w-[28.125rem]"
                src="/img/discount-cards.png"
                format="png"
                width="450"
                height="450"
            />
          </div>
          <div class="flex flex-auto w-full md:w-1/2 flex-col order-1 md:order-2 md:pl-2 box-border">
            <div class="flex flex-none sm:mb-[1.375rem] text-[#15181E] lg:text-[4.75rem] xl:text-[5.5rem] font-[850] leading-[5.625rem] md:text-[3.5rem] text-[3.75rem] mb-[1.375rem] justify-center md:justify-start">
              {{ $t("pst-private.landing.up-to") }} -{{upToPercent}}%
            </div>
            <div class="flex flex-none text-[#15181E] sm:text-[2.25rem] font-[550] leading-[2.5rem] text-[1.75rem] justify-center text-center md:text-left md:justify-start">
              {{ $t("pst-private.landing.top-up-discount") }}
            </div>
            <div class="flex flex-none flex-row mt-[2.5rem] mb-[2.5rem] block-regular-private md:ml-0 md:mr-0 mx-auto">
              <div class="block-regular-private__regular-discount">
                <span class="block-regular-private__regular-discount__text-percent">{{regularPercent}}%</span>
                <div class="block-regular-private__regular-discount__line-through"></div>
                <div class="block-regular-private__regular-discount__text-regular">
                  {{ $t("pst-private.landing.regular-discount") }}
                </div>
              </div>
              <div class="block-regular-private__layer-1"></div>
              <div class="block-regular-private__layer-2"></div>
              <div class="block-regular-private__layer-3 text-[#FF7D00] text-[4.375rem] font-[850] leading-[6.25rem] text-center">
                {{privatePercent}}%
                <div class="block-regular-private__layer-3__text-private">
                  {{ $t("pst-private.landing.private-discount") }}
                </div>
              </div>
            </div>
            <div class="flex-none mt-10 md:ml-0 md:mr-0 mx-auto hidden md:flex">
              <a href="#" @click.stop="onClickSubscribe">
                <div class="btn-common btn-black !h-[4rem] !text-[1.25rem] font-[480] leading-7">
                  {{ $t("pst-private.landing.subscribe-from") }} {{ startPriceUsd }}&nbsp;$
                </div>
              </a>
            </div>
          </div>
          <div class="flex md:hidden order-3 my-5 md:ml-0 md:mr-0 mx-auto">
            <a href="#" @click.stop="onClickSubscribe">
              <div class="btn-common btn-black !h-[4rem] !text-[1.25rem] font-[480] leading-7">
                {{ $t("pst-private.landing.subscribe-from") }} {{ startPriceUsd }}&nbsp;$
              </div>
            </a>
          </div>
        </div>

        <!-- Cashback Private -->
        <div class="flex flex-none w-full flex-col my-[3.75rem] p-[1rem] sm:p-[2.5rem]">
          <div class="flex flex-none text-white text-[3.75rem] md:text-[4.25rem] lg:text-[5.625rem] font-[850] leading-[5.625rem] mb-[1.375rem] md:justify-start justify-center text-center md:text-left">
            {{ $t("pst-private.landing.cashback-private") }} PRIVATE
          </div>
          <div class="flex flex-none flex-row flex-wrap justify-between">
            <div class="flex flex-none flex-col w-full md:w-1/2 justify-center">
              <div class="flex flex-none max-h-[36.875rem] flex-col space-y-10">
                <div class="flex flex-none text-white text-[2.25rem] font-[550] leading-10 md:justify-start justify-center">
                  {{ $t("pst-private.landing.its-profitable") }}
                </div>
                <div class="flex flex-none text-[1.5rem] font-[400] leading-7 text-white md:justify-start justify-center text-center md:text-left">
                  {{ $t("pst-private.landing.cashback-private-real-money", {p: 'PRIVATE'}) }}
                </div>
                <div class="flex flex-none flex-col ">
                  <div class="flex flex-row m-auto md:m-0 justify-between items-center text-[#FF7D00] text-[3.125rem] md:text-[3.438rem] font-[850] leading-[5rem] max-w-[25rem] h-[5rem]">
                    <div class="flex flex-none">
                      {{cashbackUsd}} $
                    </div>
                    <div class="flex flex-none">
                      ・
                    </div>
                    <div class="flex flex-none">
                      {{cashbackPercent}} %
                    </div>

                  </div>
                  <div class="flex flex-none text-[#6E7687] text-[1.5rem] md:justify-start justify-center">
                    {{ $t("pst-private.landing.for-any-ads") }}
                  </div>
                </div>
                <div class="flex-none hidden md:flex">
                  <a href="#" @click.stop="onClickSubscribe">
                    <div class="btn-common btn-white !h-[4rem] !text-[1.25rem] font-[480] leading-7">
                      {{ $t("pst-private.landing.subscribe-from") }} {{ startPriceUsd }}&nbsp;$
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div class="flex flex-none w-full md:w-1/2">
              <nuxt-img
                class="lg:rendering-pixelated w-full h-fit m-auto max-w-[32.438rem]"
                src="/img/block-cashback-private.png"
                format="png"
                width="519"
                height="519"
              />
            </div>
            <div class="flex-none flex md:hidden order-3 m-auto">
              <a href="#" @click.stop="onClickSubscribe">
                <div class="btn-common btn-white !h-[4rem] !text-[1.25rem] font-[480] leading-7">
                  {{ $t("pst-private.landing.subscribe-from") }} {{ startPriceUsd }}&nbsp;$
                </div>
              </a>
            </div>
          </div>

        </div>

        <!-- Also in PRIVATE-->
        <div class="flex flex-none flex-col w-full p-10 rounded-[2.5rem] bg-[#F3F4F7]">
          <div class="flex flex-none text-[#15181E] text-[3.75rem] md:text-[4.375rem] lg:text-[5.625rem] font-[850] leading-[5.625rem] mb-[1.375rem] md:justify-start justify-center text-center md:text-left">
            {{ $t("pst-private.landing.also-in-private", { p: 'PRIVATE' }) }}
          </div>
          <div class="flex flex-none text-[2.25rem] font-[550] leading-10 text-[#15181E] md:justify-start justify-center text-center md:text-left">
            {{ $t("pst-private.landing.in-each-plan") }}
          </div>
          <div class="flex flex-row w-full flex-wrap my-10">
            <div class="flex flex-none w-[12.5rem] h-[12.5rem] grow justify-between flex-col bg-white rounded-[1.875rem] p-5 m-[0.313rem]">
              <div class="flex flex-none">
                <Icon name="card" class="text-[#B8BECC] w-[2.563rem] h-[2.563rem]"/>
              </div>
              <div class="flex flex-none text-[#15181E] text-[1.25rem] font-[400] leading-7">
                {{ $t("pst-private.landing.more-then-40") }}
              </div>
            </div>
            <div class="flex flex-none w-[12.5rem] box-border h-[12.5rem] grow justify-between flex-col bg-white rounded-[1.875rem] p-5 m-[0.313rem]">
              <div class="flex flex-none">
                <Icon name="crown-outlined" class="text-[#B8BECC] w-[2.563rem] h-[2.563rem]"/>
              </div>
              <div class="flex flex-none text-[#15181E] text-[1.25rem] font-[400] leading-7">
                {{ $t("pst-private.landing.5-bins") }}
              </div>
            </div>
            <div class="flex flex-none w-[12.5rem] h-[12.5rem] grow justify-between flex-col bg-white rounded-[1.875rem] p-5 m-[0.313rem]">
              <div class="flex flex-none">
                <Icon name="team" class="text-[#B8BECC] w-[2.563rem] h-[2.563rem]"/>
              </div>
              <div class="flex flex-none text-[#15181E] text-[1.25rem] font-[400] leading-7">
                {{ $t("pst-private.landing.team-access") }}
              </div>
            </div>
            <div class="flex flex-none w-[12.5rem] h-[12.5rem] grow justify-between flex-col bg-white rounded-[1.875rem] p-5 m-[0.313rem]">
              <div class="flex flex-none">
                <Icon name="clock" class="text-[#B8BECC] w-[2.563rem] h-[2.563rem]"/>
              </div>
              <div class="flex flex-none text-[#15181E] text-[1.25rem] font-[400] leading-7">
                {{ $t("pst-private.landing.fast-track-withdrawal") }}
              </div>
            </div>
            <div class="flex flex-none w-[12.5rem] h-[12.5rem] grow justify-between flex-col bg-white rounded-[1.875rem] p-5 m-[0.313rem]">
              <div class="flex flex-none">
                <Icon name="support" class="text-[#B8BECC] w-[2.563rem] h-[2.563rem]"/>
              </div>
              <div class="flex flex-none text-[#15181E] text-[1.25rem] font-[400] leading-7">
                {{ $t("pst-private.landing.private-manager") }}
              </div>
            </div>
          </div>

          <div class="flex flex-none m-auto md:m-0">
            <a href="#" @click.stop="onClickSubscribe">
              <div class="btn-common btn-black !h-[4rem] !text-[1.25rem] font-[480] leading-7">
                {{ $t("pst-private.landing.subscribe-from") }} {{ startPriceUsd }}&nbsp;$
              </div>
            </a>
          </div>

        </div>

      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { Icon } from "~/components/Ui";
import {onDashboard} from "~/helpers/events";
import {getPrivateQueryParam} from "~/helpers/private";
import {useI18n} from "vue-i18n";

const startPriceUsd = 9;
const regularPercent = 8;
const privatePercent = 2;
const upToPercent = 75;
const cashbackPercent = 3;
const cashbackUsd = 5000;
const { t } = useI18n();

useHead({
  htmlAttrs: {
    class: "dark",
  },
});

useSeoMeta({
  title: t("page.private.seo.title"),
  description: t("page.private.seo.description"),
  ogTitle: t("page.private.seo.title"),
  ogDescription: t("page.private.seo.description")
});

const onClickSubscribe = () => {
  onDashboard(
      'landing-private_start-subscribe',
      `/register?${getPrivateQueryParam()}`,
      {},
      {},
      true
  );
}

</script>
<style lang="scss" scoped>

.content {
  @apply flex flex-col min-h-screen;
}

.rendering-pixelated { image-rendering: pixelated; }

.main {
  @apply w-full h-full bg-[#15191D] flex flex-col pb-10 pt-28;
  font-family: 'ALS Granate VF';
  -webkit-font-smoothing: antialiased;

  &__container {
    @apply w-full mx-auto px-5 space-y-5 flex flex-col;

    .content {
      @apply flex flex-col w-full max-w-[71.25rem] mx-auto;
    }
    .footer {
      @apply flex;
    }
  }
}

.block-regular-private {
  @apply w-[21.75rem] h-[6.25rem] relative rounded-[1.875rem];

  background: linear-gradient(270deg, #D0D4DD 0%, rgba(208, 212, 221, 0.00) 100%);

  &__regular-discount {
    &__line-through {
      @apply h-[0.25rem] absolute left-0 w-full;
      content: " ";
      background: rgba(0, 0, 0, 0.36);
      top: calc(50% - 0.125rem);
    }

    &__text-regular {
      @apply absolute bottom-[-2.25rem] text-center text-[1.5rem] text-[#6E7687] font-[400] leading-[1.75rem] w-full;
    }

    &__text-percent {
      background: linear-gradient(270deg, #6E7687 0.16%, rgba(110, 118, 135, 0.00) 117.18%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    @apply left-[1.875rem] absolute text-[4.375rem] font-[850] leading-[6.25rem];
  }

  &__layer-1 {
    @apply w-[10.25rem] h-[6.25rem] right-[1.875rem] absolute z-[1] rounded-[1.875rem] bg-white opacity-30;
  }
  &__layer-2 {
    @apply w-[10.25rem] h-[6.25rem] right-[0.938rem] absolute z-[2] rounded-[1.875rem] bg-white opacity-60;
  }
  &__layer-3 {
    @apply w-[10.25rem] h-[6.25rem] right-[0] absolute z-[3] rounded-[1.875rem] bg-white;
    box-shadow: -0.25rem 0rem 0.25rem 0rem rgba(0, 0, 0, 0.04);

    &__text-private {
      @apply absolute bottom-[-2.25rem] text-[#6E7687] text-center text-[1.5rem] font-[400] leading-[1.75rem] w-full;
    }
  }
}

.btn-common {
  @apply flex h-12 px-3 justify-center text-center items-center rounded-[0.75rem] text-[1rem] font-[500] leading-6 hover:opacity-70 transition-all;
}
.btn-white {
  @apply bg-white text-[#15191D];
}
.btn-black {
  @apply bg-[#15191D] text-white;
}
.btn-gray {
  @apply text-white;
  background: linear-gradient(0deg, rgba(255, 255, 255, 0.20) 0%, rgba(255, 255, 255, 0.20) 100%), #15191D;
}
.btn-orange {
  @apply bg-[#FF7D00] text-white;
}
</style>